module.exports = __webpack_public_path__ + "img/gb807.prt.eda21d62.jpg";